module.exports = __webpack_public_path__ + "static/img/AICircle.c985c8f2.png";